import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_log_glory_event.js";
//#region src/bite_log_glory_event_helper.ts
var bite_log_glory_event_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(event) {
	switch (event) {
		case 1: return "open-request-success";
		case 2: return "open-request-error";
		case 3: return "occupancy-request-success";
		case 4: return "occupancy-request-error";
		case 5: return "register-event-request-success";
		case 6: return "register-event-request-error";
		case 7: return "adjust-time-request-success";
		case 8: return "adjust-time-request-error";
		case 9: return "get-status-request-success";
		case 10: return "get-status-request-error";
		case 11: return "inventory-request-success";
		case 12: return "inventory-request-error";
		case 13: return "close-request-success";
		case 14: return "close-request-error";
		case 15: return "sale-transaction-success";
		case 16: return "sale-transaction-error";
		case 17: return "change-cancel-request-success";
		case 18: return "change-cancel-request-error";
		case 19: return "update-manual-deposit-request-success";
		case 20: return "update-manual-deposit-request-error";
		case 21: return "status-change-event";
		case 22: return "open-sequence-success";
		case 23: return "open-sequence-error";
		case 24: return "change-response-event";
		case 25: return "transaction-interrupted";
		case 26: return "event-subscription-error";
		case 27: return "kiosk-cash-machine-state-changed";
		case 28: return "inventory-event-success";
		case 29: return "inventory-event-error";
		case 30: return "parse-error";
		case 31: return "cancel-payment-cash-out-not-match-cash-in";
		case 32: return "transaction-cancelled";
		case 33: return "transaction-cancellation-error";
	}
}
//#endregion
export { bite_log_glory_event_helper_exports, name };

//# sourceMappingURL=bite_log_glory_event_helper.js.map